import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../Asset/Yashavi.png";
import "./Footer.css";
import { FaLinkedinIn, FaInstagram, FaFacebookF, FaYoutube, FaLocationDot, FaPhone, FaEnvelope, FaArrowRight, FaChevronRight,
} from "react-icons/fa6";

const QUICK_LINKS = [
  { label: "Home", href: "/" },
  { label: "About Us", href: "/about" },
  { label: "Services", href: "/services" },
  { label: "Portfolio", href: "/portfolio" },
  // { label: "Careers", href: "/careers" },
  { label: "Training", href: "/internship" },
  { label: "Contact", href: "/contact" },
   { label: "Login", href: "/login" },
];

const SOCIALS = [
  { icon: <FaLinkedinIn />, href: "https://www.linkedin.com/company/yashvitech-it-solution-pvt-ltd/", label: "LinkedIn", color: "#0A66C2" },
  { icon: <FaInstagram />,  href: "https://www.instagram.com/yashvitechraipur/", label: "Instagram", color: "#E1306C" },
  { icon: <FaFacebookF />,  href: "https://www.facebook.com/people/Yashvitech-Raipur/61554162039733/#", label: "Facebook", color: "#1877F2" },
  { icon: <FaYoutube />,    href: "https://www.youtube.com/@yashvitech", label: "YouTube", color: "#FF0000" },
];

const CONTACT_INFO = [
  {
    icon: <FaLocationDot />,
    label: "Address",
    value: "Near Disha College, Kota, Raipur, C.G.",
    href: "https://www.google.com/maps/place/YashviTech+IT+Solution/@21.251595,81.610679,2108m/data=!3m1!1e3!4m6!3m5!1s0x3a28dd860cf3c217:0x493efc4d076691fb!8m2!3d21.2515945!4d81.6106793!16s%2Fg%2F11vf4_xvj9?entry=ttu&g_ep=EgoyMDI2MDcwOC4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    icon: <FaPhone />,
    label: "Phone",
    value: "+91 86400-91593",
    href: "tel:+918640091593",
  },
  {
    icon: <FaEnvelope />,
    label: "Email",
    value: "info.yashvitech@gmail.com",
    href: "mailto:info.yashvitech@gmail.com",
  },
];

export default function Footer() {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);
  const [error, setError] = useState("");

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      setError("Please enter a valid email address.");
      return;
    }
    setError("");
    setSubscribed(true);
    setEmail("");
  };

  return (
    <footer className="footer">
      <div className="footer-accent-bar" />

      <div className="footer-main">
        <div className="footer-grid">
          
          {/* Col 1 — Brand */}
          <div className="footer-col brand-col">
            <img style={{ width: '220px' }} src={logo} alt="Yashvitech Logo" />
            <p className="footer-tagline">
              Building secure, scalable & future-ready digital solutions for modern businesses.
            </p>
            <div className="footer-socials">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  className="social-icon"
                  aria-label={s.label}
                  title={s.label}
                  style={{ "--sc": s.color }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Col 2 — Quick Links */}
          <div className="footer-col">
            <h4 className="footer-heading">
              <span className="heading-line" />
              Quick Links
            </h4>
            <ul className="footer-links">
              {QUICK_LINKS.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.href}
                    className="footer-link"
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                  >
                    <FaChevronRight className="link-arrow" />
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3 — Newsletter */}
          <div className="footer-col">
            <h4 className="footer-heading">
              <span className="heading-line" />
              Newsletter
            </h4>
            {!subscribed ? (
              <form className="newsletter-form" onSubmit={handleSubscribe} noValidate>
                <p className="newsletter-desc">
                  Subscribe to get tech insights and company updates.
                </p>
                <div className="newsletter-input-wrap">
                  <FaEnvelope className="nl-icon" />
                  <input
                    type="email"
                    className={`newsletter-input${error ? " error" : ""}`}
                    placeholder="Your email address"
                    value={email}
                    onChange={(e) => { setEmail(e.target.value); setError(""); }}
                  />
                </div>
                {error && <span className="nl-error">{error}</span>}
                <button type="submit" className="newsletter-btn">
                  Subscribe <FaArrowRight />
                </button>
              </form>
            ) : (
              <div className="subscribed-msg">
                <span className="subscribed-icon">✅</span>
                <p>You're subscribed!</p>
              </div>
            )}
          </div>

          {/* Col 4 — Contact */}
          <div className="footer-col">
            <h4 className="footer-heading">
              <span className="heading-line" />
              Contact Us
            </h4>
            <div className="contact-list">
              {CONTACT_INFO.map((c) => (
                <a key={c.label} href={c.href} className="contact-item" target="_blank" rel="noopener noreferrer">
                  <span className="contact-icon-wrap">{c.icon}</span>
                  <div className="contact-text">
                    <span className="contact-label">{c.label}</span>
                    <span className="contact-value">{c.value}</span>
                  </div>
                </a>
              ))}
            </div>
          </div>

        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <p className="copyright">
            © {new Date().getFullYear()} YashviTech IT Solution Pvt. Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}